import { Action } from '@ngrx/store';
import { JwtHelperService } from '@auth0/angular-jwt';

export const CORE_ACTION = {
  WEBAPP_UPDATE_CLP_CONFIG: '[Core Action] CLP config updated for SECO application',
  DIRECT_UPDATE_CLP_CONFIG: '[Core Action] CLP config updated for Direct application',
  CLP_UPDATE_RESPONSE: '[Core Action] Update response from CLP service',
  DIRECT_USER_LOGGED_IN: '[Core Action] User is logged in to Amadeus Direct',
  DIRECT_REFRESH_PAGE: '[Core Action] User refreshed page',
  DIRECT_JWT_GENERATED: '[Core Action] Direct Jwt is generated',
  DIRECT_SESSION_BANNER: '[Core Action] Session banner update',
  DIRECT_RESUME_SESSION: '[Core Action] Resume Direct session',
  DIRECT_REGISTRATION: '[Core Action] User is not exists, should be registered',
  DIRECT_AGREEMENT: '[Core Action] User is exists, but agreement should be signed',
  DIRECT_USER_LOGGED_OUT: '[Core Action] User is loggout from Amadeus Direct',
  DIRECT_USER_LOGIN_ERROR: '[Core Action] User is not logged in to Amadeus Direct',
  WEBAPP_USER_LOGGED_IN: '[Core Action] User is logged in to Webapp',
  INIT_CUSTOMER_CONFIG: '[CUSTOMER] Init customer config',
  SET_PO_CUSTOMER_CONFIG: '[CUSTOMER] Set customer as product orderer in customer config',
  SET_FM_CUSTOMER_CONFIG: '[CUSTOMER] Set customer as financial manager in customer config',
  SET_AVC_DASHBOARDS_CUSTOMER_CONFIG: '[CUSTOMER] Set customer to see AVC Dashboards',
  SET_AVC_INVOICES_CUSTOMER_CONFIG: '[CUSTOMER] Set customer to see AVC Invoices',
  SET_AVC_CREDIT_LINE_STATUS_CUSTOMER_CONFIG: '[CUSTOMER] Set customer to see AVC credit line status',
  SET_SV_CUSTOMER_CONFIG: '[CUSTOMER] Set customer as having sales view access in customer config',
  SET_SNOW_CUSTOMER_CONFIG: '[CUSTOMER] Set customer as having ServiceNow view in customer config',
  INIT_LOCALE_LIST: '[LOCALE] init',
  DIRECT_USER_ROLE_HAS_BEEN_CHANGED: '[Core Action] User role has been changed',
  GET_CLP_CONFIG_ERROR: '[Core Action] Get CLP config error',
  GET_LOCALE_LIST_ERROR: '[Core Action] Get locale list error',
  GET_MENU_LIST_ERROR: '[Core Action] Get menu list error',
  GET_AVC_TA_CURRENCY: '[Currency] Get AVC TA Currency'
};

class TokenAction {
  private jwtService: JwtHelperService;

  constructor() {
    this.jwtService = new JwtHelperService();
  }

  protected parseToken(token: string) {
    return this.jwtService.decodeToken(token);
  }
}

export enum DirectPermissionsList {
  book = 'book'
}

export type DirectPermissions = { [key in DirectPermissionsList]?: boolean };

class ClpTokenAction extends TokenAction {
  constructor(public payload: any) {
    super();
    this.payload.permissions = this.getPermissions();
  }

  private getPermissions(): DirectPermissions {
    if (!this.payload.idToken) {
      return {};
    }
    const token = this.parseToken(this.payload.idToken);
    const v2 = token['permissions_v2'];
    return v2
      ? {
          [DirectPermissionsList.book]: v2['SLW'] ? v2['SLW'].indexOf('SIGN_IN_TO_SELL_CONNECT') > -1 : false
        }
      : {};
  }
}

export class DirectLocaleList implements Action {
  readonly type = CORE_ACTION.INIT_LOCALE_LIST;
  constructor(public payload?: any) {}
}

export class WebappUpdateClpConfig implements Action {
  readonly type = CORE_ACTION.WEBAPP_UPDATE_CLP_CONFIG;
  constructor(public payload: any) {}
}

export class DirectUpdateClpConfig implements Action {
  readonly type = CORE_ACTION.DIRECT_UPDATE_CLP_CONFIG;
  constructor(public payload: any) {}
}

export class ClpUpdateResponse extends ClpTokenAction implements Action {
  readonly type = CORE_ACTION.CLP_UPDATE_RESPONSE;
  constructor(public payload: any) {
    super(payload);
  }
}

export class DirectLoggedIn implements Action {
  readonly type = CORE_ACTION.DIRECT_USER_LOGGED_IN;
  constructor(public payload: any) {}
}

export class DirectRefreshPage implements Action {
  readonly type = CORE_ACTION.DIRECT_REFRESH_PAGE;
  constructor(public payload?: any) {}
}

export class DirectJwtGenerated implements Action {
  readonly type = CORE_ACTION.DIRECT_JWT_GENERATED;
  constructor(public payload?: any) {}
}

export class DirectSessionBanner implements Action {
  readonly type = CORE_ACTION.DIRECT_SESSION_BANNER;
  constructor(public payload?: any) {}
}

export class DirectResumeSession implements Action {
  readonly type = CORE_ACTION.DIRECT_RESUME_SESSION;
  constructor(public payload?: any) {}
}

export class DirectRegistration implements Action {
  readonly type = CORE_ACTION.DIRECT_REGISTRATION;
  constructor(public payload: any) {}
}

export class DirectAgreement implements Action {
  readonly type = CORE_ACTION.DIRECT_AGREEMENT;
  constructor(public payload: any) {}
}

export class DirectLoggedOut implements Action {
  readonly type = CORE_ACTION.DIRECT_USER_LOGGED_OUT;
  constructor(public payload?: any) {}
}

export class DirectUserRoleHasBeenChanged implements Action {
  readonly type = CORE_ACTION.DIRECT_USER_ROLE_HAS_BEEN_CHANGED;
  constructor() {}
}

export class WebAppLoggedIn implements Action {
  readonly type = CORE_ACTION.WEBAPP_USER_LOGGED_IN;
  constructor(public payload?: any) {}
}

export class DirectLoggedInError implements Action {
  readonly type = CORE_ACTION.DIRECT_USER_LOGIN_ERROR;
  constructor(public payload?: any) {}
}

export class InitCustomerConfig implements Action {
  readonly type = CORE_ACTION.INIT_CUSTOMER_CONFIG;
  constructor(public payload?: any) {}
}

export class SetPOCustomerConfig implements Action {
  readonly type = CORE_ACTION.SET_PO_CUSTOMER_CONFIG;
  constructor() {}
}

export class SetFMCustomerConfig implements Action {
  readonly type = CORE_ACTION.SET_FM_CUSTOMER_CONFIG;
  constructor() {}
}

export class SetAVCDashboardsCustomerConfig implements Action {
  readonly type = CORE_ACTION.SET_AVC_DASHBOARDS_CUSTOMER_CONFIG;
  constructor() {}
}

export class SetAVCInvoicesCustomerConfig implements Action {
  readonly type = CORE_ACTION.SET_AVC_INVOICES_CUSTOMER_CONFIG;
  constructor() {}
}

export class SetAVCCreditLineStatusCustomerConfig implements Action {
  readonly type = CORE_ACTION.SET_AVC_CREDIT_LINE_STATUS_CUSTOMER_CONFIG;
  constructor() {}
}

export class SetSVCustomerConfig implements Action {
  readonly type = CORE_ACTION.SET_SV_CUSTOMER_CONFIG;
  constructor() {}
}

export class SetSNOWCustomerConfig implements Action {
  readonly type = CORE_ACTION.SET_SNOW_CUSTOMER_CONFIG;
  constructor() {}
}

export class GetClpConfigError implements Action {
  readonly type = CORE_ACTION.GET_CLP_CONFIG_ERROR;
  constructor(public payload?: any) {}
}

export class GetLocaleListError implements Action {
  readonly type = CORE_ACTION.GET_LOCALE_LIST_ERROR;
  constructor(public payload?: any) {}
}

export class GetMenuListError implements Action {
  readonly type = CORE_ACTION.GET_MENU_LIST_ERROR;
  constructor(public payload?: any) {}
}

export class GetAVCCurrency implements Action {
  readonly type = CORE_ACTION.GET_AVC_TA_CURRENCY;
  constructor(public payload?: any) {}
}

export type CoreActions =
  | WebappUpdateClpConfig
  | WebAppLoggedIn
  | DirectLoggedIn
  | DirectLoggedOut
  | DirectUpdateClpConfig
  | DirectRegistration
  | DirectAgreement
  | DirectLoggedInError
  | ClpUpdateResponse
  | InitCustomerConfig
  | SetPOCustomerConfig
  | SetFMCustomerConfig
  | SetAVCDashboardsCustomerConfig
  | SetAVCInvoicesCustomerConfig
  | SetAVCCreditLineStatusCustomerConfig
  | SetSVCustomerConfig
  | DirectSessionBanner
  | DirectJwtGenerated
  | DirectRefreshPage
  | DirectLocaleList
  | DirectUserRoleHasBeenChanged
  | GetClpConfigError
  | GetLocaleListError
  | GetMenuListError
  | GetAVCCurrency;
